import ax4 from "assets/images/biti.jpg";
import styles from "../blogComponent/blog.module.css";
import styles1 from "./matlab.module.css";
import { BiTimeFive } from "react-icons/bi";
import ax1 from "assets/images/ax1.svg";
import ax2 from "assets/images/ax2.svg";
import ax3 from "assets/images/ax3.svg";
import SwiperCore, { Autoplay } from "swiper";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
const TakMatlab = () => {
  return (
    <div className="mb-5 pb-1 mt-5 container m-auto ">
      <img src={ax4} className={` ${styles1.wAx}`} />
      <div className="my-4 ">
        <h1>
          <bdi>2022</bdi> ، سال پرخبر و پرنوسان ارزهای دیجیتال
        </h1>
        <div className="mt-3 d-flex w-100 justify-content-between">
          <div className="d-flex justify-content-between">
            <p className={styles1.hamArz}>اخبار هم ارزها</p>
            <p className="my-1 mx-4">دو ماه پیش</p>
          </div>
          <div className="d-flex justify-content-between">
            <p className="my-1 ">
              <bdi className="mx-2">
                <BiTimeFive />
              </bdi>
              6 دقیقه پیش{" "}
            </p>
          </div>
        </div>

        <p className="mt-5 mb-3 ">
          سال ۲۰۲۱ با فراز و فرودهایش برای ارزهای دیجیتال به پایان رسید. اگر
          بخواهیم به مروری بر اتفاقات دنیای ارزهای دیجیتال در سال ۲۰۲۱ بپردازیم
          اول باید اشاره‌ای به قیمت بیت کوین بکنیم که در نخستین روز سال ۲۰۲۱
          یعنی دوازدهم دی ۱۳۹۹، ۲۹ هزار دلار بود. قیمت اتریوم هم در آن روز ۷۲۹
          دلار بوده است. حالا امروز در نخستین روز سال ۲۰۲۲ قیمت بیت کوین با وجود
          ریزش‌های چند وقت اخیر در محدوده ۴۷ هزار دلار و قیمت اتریوم در کانال
          ۳۷۰۰ دلار است.
        </p>
        <p className="mt-4 mb-5 ">
          در سال ۲۰۲۱ شرکت های زیادی رمزارزها را به‌عنوان یک دارایی پذیرفتند و
          حتی یک کشور، بیت‌کوین را به عنوان یکی از ارزهای رسمی این کشور پذیرفت و
          شنیده شده کشورهای دیگری نیز در حال برنامه‌ریزی برای همین کار هستند.
          عملکرد شرکت‌ها و اعلام چشم‌اندازهایشان، حاکی از این است که ارزهای
          دیجیتال در ابتدای راه پذیرش و سرمایه‌گذاری ازسوی شرکت‌های بزرگ هستند.
          محبوبیت بیت کوین باعث شد تا بازار کریپتو رکوردهای جدیدی بزند و قیمت
          بیت کوین در روزهایی در سال ۲۰۲۱ به ۶۸ هزار دلار نیز رسید و به دنبال
          آن، آلت‌کوین‌ها نیز شاهد رشدهای بسیار زیادی بودند.
        </p>
        <h1 className="mt-5 ">چین در برابر ماینینگ</h1>
        <p className="mt-3 mb-5 ">
          در سال ۲۰۲۱ شرکت های زیادی رمزارزها را به‌عنوان یک دارایی پذیرفتند و
          حتی یک کشور، بیت‌کوین را به عنوان یکی از ارزهای رسمی این کشور پذیرفت و
          شنیده شده کشورهای دیگری نیز در حال برنامه‌ریزی برای همین کار هستند.
          عملکرد شرکت‌ها و اعلام چشم‌اندازهایشان، حاکی از این است که ارزهای
          دیجیتال در ابتدای راه پذیرش و سرمایه‌گذاری ازسوی شرکت‌های بزرگ هستند.
          محبوبیت بیت کوین باعث شد تا بازار کریپتو رکوردهای جدیدی بزند و قیمت
          بیت کوین در روزهایی در سال ۲۰۲۱ به ۶۸ هزار دلار نیز رسید و به دنبال
          آن، آلت‌کوین‌ها نیز شاهد رشدهای بسیار زیادی بودند.
        </p>
        <p className="mt-4 mb-5">
          انتقال ماینرها از چین به مغولستان و کشورهای دیگر باعث شد بیت کوین که
          در بازه‌ای از ۶۸ هزار دلار به ۲۸ هزار دلار نیز رسید، به سرعت خود را
          بازیابی کند و به محدوده ۶۴ هزار دلار برسد. اما دوباره خبرهایی از چین و
          سایر اتفاقات، باعث ریزش قیمت تا محدوده ۴۲ هزار دلار شد و البته باز هم
          قیمت به سمت بالا خیز برداشت. در مجموع با وجود همه این نوسانات، بازار
          در سال ۲۰۲۱ صعودی بوده و از ۲۹ هزار دلار به …. دلار رسیده است.
        </p>
        <h1 className="mt-5 ">خودپردازهای ارز دیجیتال</h1>
        <p className="mt-3 mb-5 ">
          در سال ۲۰۲۱ شرکت های زیادی رمزارزها را به‌عنوان یک دارایی پذیرفتند و
          حتی یک کشور، بیت‌کوین را به عنوان یکی از ارزهای رسمی این کشور پذیرفت و
          شنیده شده کشورهای دیگری نیز در حال برنامه‌ریزی برای همین کار هستند.
          عملکرد شرکت‌ها و اعلام چشم‌اندازهایشان، حاکی از این است که ارزهای
          دیجیتال در ابتدای راه پذیرش و سرمایه‌گذاری ازسوی شرکت‌های بزرگ هستند.
          محبوبیت بیت کوین باعث شد تا بازار کریپتو رکوردهای جدیدی بزند و قیمت
          بیت کوین در روزهایی در سال ۲۰۲۱ به ۶۸ هزار دلار نیز رسید و به دنبال
          آن، آلت‌کوین‌ها نیز شاهد رشدهای بسیار زیادی بودند.
        </p>
        <h1 className="mt-5 ">متاورس و دنیای رمزارزهای</h1>
        <p className="mt-3 mb-5 ">
          در سال ۲۰۲۱ شرکت های زیادی رمزارزها را به‌عنوان یک دارایی پذیرفتند و
          حتی یک کشور، بیت‌کوین را به عنوان یکی از ارزهای رسمی این کشور پذیرفت و
          شنیده شده کشورهای دیگری نیز در حال برنامه‌ریزی برای همین کار هستند.
          عملکرد شرکت‌ها و اعلام چشم‌اندازهایشان، حاکی از این است که ارزهای
          دیجیتال در ابتدای راه پذیرش و سرمایه‌گذاری ازسوی شرکت‌های بزرگ هستند.
          محبوبیت بیت کوین باعث شد تا بازار کریپتو رکوردهای جدیدی بزند و قیمت
          بیت کوین در روزهایی در سال ۲۰۲۱ به ۶۸ هزار دلار نیز رسید و به دنبال
          آن، آلت‌کوین‌ها نیز شاهد رشدهای بسیار زیادی بودند.
        </p>
      </div>
      <div className={`m-auto mt-4  `}>
        {" "}
        <h1 className={styles.newsText}> آخرین اخبار</h1>
      </div>
      <div className={`   justify-content-evenly m-auto `}>
        <Swiper
          spaceBetween={10}
          slidesPerView={1}
          loop={true}
          observer={true}
          observeParents={true}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          autoplay={{ delay: 1000, pauseOnMouseEnter: true }}
          breakpoints={{
            // when window width is >= 320px

            400: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            // when window width is >= 535px
            429: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            700: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            // when window width is >= 992px
            992: {
              slidesPerView: 4,
              spaceBetween: 10,
            },
            1200: {
              slidesPerView: 4,
              spaceBetween: 10,
            },
          }}
          key={Math.random() * 50}
        >
          <div className="swiper-button-prev "></div>
          <div className="swiper-button-next "></div>
          <SwiperSlide
            className={`d-flex flex-column my-5 justify-content-evenly align-items-center text-light ${styles.cryptCard} ${styles.point}`}
          >
            <img src={ax4} className={styles.ax1} />
            <div className={styles.up}>
              <div className="d-flex justify-content-around flex-column h-50 w-100"></div>
              <div className="d-flex justify-content-around flex-column h-50 w-100">
                <p className={`mx-2 ${styles.fontDigi}`}>
                  گذاران در سال ۲۰۲۱ تبدیل{" "}
                </p>
                <div className="d-flex justify-content-around w-100">
                  <small className={` ${styles.fontSm}`}>نیما ملک پور</small>
                  <small className={` ${styles.fontSm}`}>
                    <bdi>3</bdi>
                    ساعت پیش
                  </small>
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide
            className={`d-flex flex-column my-5  justify-content-evenly align-items-center text-light ${styles.cryptCard2} ${styles.point} `}
          >
            <img src={ax1} className={styles.ax1} />
            <div className={styles.up}>
              <div className="d-flex justify-content-around flex-column h-50 w-100"></div>
              <div className="d-flex justify-content-around flex-column h-50 w-100">
                <p className={`mx-2 ${styles.fontDigi}`}>
                  رشد رمزار‌ها و استخراج بیت کوین با انرژی آتش‌فشان در
                  السالوادور
                </p>
                <div className="d-flex justify-content-around w-100">
                  <small className={styles.fontSm}>نیما ملک پور</small>
                  <small className={styles.fontSm}>
                    <bdi>3</bdi>
                    ساعت پیش
                  </small>
                </div>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide
            className={`d-flex flex-column my-5 justify-content-evenly align-items-center text-light ${styles.cryptCard3} ${styles.point}`}
          >
            <img src={ax2} className={styles.ax1} />
            <div className={styles.up}>
              <div className="d-flex justify-content-around flex-column h-50 w-100"></div>
              <div className="d-flex justify-content-around flex-column h-50 w-100">
                <p className={`mx-2 ${styles.fontDigi}`}>
                  رشد چشمگیر ارزهای دیجیتال در ۱ اکتبر
                </p>
                <div className="d-flex justify-content-around w-100">
                  <small className={styles.fontSm}>نیما ملک پور</small>
                  <small className={styles.fontSm}>
                    <bdi>3</bdi>
                    ساعت پیش
                  </small>
                </div>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide
            className={`d-flex flex-column my-5 justify-content-evenly align-items-end text-light ${styles.cryptCard4} ${styles.point} `}
          >
            <img src={ax3} className={styles.ax1} />
            <div className={styles.up}>
              <div className="d-flex justify-content-around flex-column h-50 w-100"></div>
              <div className="d-flex justify-content-around flex-column h-50 w-100">
                <p className={`mx-2 ${styles.fontDigi}`}>
                  رشد چشمگیر ارزهای دیجیتال در ۱ اکتبر
                </p>
                <div className="d-flex justify-content-around w-100">
                  <small className={styles.fontSm}>نیما ملک پور</small>
                  <small className={styles.fontSm}>
                    <bdi>3</bdi>
                    ساعت پیش
                  </small>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
};

export default TakMatlab;
